var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.params.value)?_c('div',[_c('b-icon',{attrs:{"icon":"check-circle-fill","font-scale":"2","variant":"success"}})],1):_c('div',[_vm._v("\n      -\n\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }